import request from "@/utils/request";

export default function agentGetOnlyChargeDeviceGroupIdNameList(params) {
  return request({
    url: `/device/deviceGroup/agentGetOnlyChargeDeviceGroupIdNameList`,
    params,
  });
}
